import { SubPageLayout } from "@/components/SubPageLayout";
import { SITE_IMAGES } from "@/lib/site-data";

export default function SatrakMobilraktarak() {
  return (
    <SubPageLayout
      eyebrow="Sátrak és mobilraktárak"
      title="Fixvázas sátrak, raktárak és előtetők ponyváinak gyártása."
      intro="Magánszemélyeknek és cégeknek: előtetők, rendezvény- és raktársátrak akár ADR tűzálló PVC ponyvából."
      heroImage="/assets/gallery/egyedi-01.jpg"
      bullets={[
        { title: "Vázszerkezet", text: "Statikailag méretezett acélváz – tartós, biztonságos megoldás." },
        { title: "Tűzálló ADR ponyva", text: "Uniós előírásoknak megfelelő rendezvény- és sátorponyvák." },
        { title: "Csak ponyva is", text: "Meglévő vázra is gyártunk méretpontos cserét." },
        { title: "Reklámfelület", text: "Egyedi nyomtatott vagy festett grafika a sátor felületén." },
      ]}
      gallery={SITE_IMAGES.tentGallery}
    />
  );
}
